import { useEffect, useState, useCallback } from 'react'
import { useLocale } from '../../App'

interface TopBarProps {
  authToken: string | null
  devProfile?: any
  refreshKey?: number
}

export function TopBar({ authToken, devProfile, refreshKey }: TopBarProps) {
  const { t } = useLocale()
  const [profile, setProfile] = useState<any>(devProfile || null)
  const [sharing, setSharing] = useState(false)

  useEffect(() => {
    if (authToken) {
      fetch('/api/user/profile', {
        headers: { Authorization: `Bearer ${authToken}` },
      })
        .then((r) => r.json())
        .then(setProfile)
        .catch(console.error)
    }
  }, [authToken, refreshKey])

  const handleShare = useCallback(async () => {
    if (!authToken || sharing) return
    setSharing(true)
    try {
      const tg = window.Telegram?.WebApp
      const url = 'https://poker.usdt.bz/s/play'
      const text = t('app.share_topbar')
      if (tg?.openTelegramLink) {
        tg.openTelegramLink(`https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`)
      } else if (tg?.shareUrl) {
        tg.shareUrl(url)
      } else {
        window.open(`https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`, '_blank')
      }
    } catch (err) {
      console.error('Share failed:', err)
    } finally {
      setSharing(false)
    }
  }, [authToken, sharing])

  const chips = profile?.chips ?? 0

  return (
    <div className="flex items-center justify-between px-4 py-3 bg-slate-900/80 backdrop-blur-md border-b border-slate-700/50">
      <div className="flex items-center gap-2.5">
        {profile?.photoUrl ? (
          <img
            src={profile.photoUrl}
            alt="avatar"
            className="h-9 w-9 rounded-full object-cover ring-2 ring-blue-500/30"
          />
        ) : (
          <div className="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-blue-700 ring-2 ring-blue-400/20">
            <span className="text-xl">👤</span>
          </div>
        )}
        <div className="flex flex-col">
          <span className="text-[16px] font-semibold text-slate-200">
            {profile?.firstName || profile?.username || '玩家'}
          </span>
          {profile?.gamesPlayed > 0 && (
            <span className="text-[12px] text-slate-500">
              {t('app.stats_line', { games: String(profile.gamesPlayed), rate: String(Math.round((profile.gamesWon / profile.gamesPlayed) * 100)) })}
            </span>
          )}
        </div>
      </div>
      <div className="flex items-center gap-2">
        <button
          onClick={handleShare}
          disabled={sharing}
          className="flex items-center justify-center rounded-full h-8 w-8 text-[14px] font-bold transition-all active:scale-95 cursor-pointer"
          style={{
            background: 'rgba(16,185,129,0.15)',
            color: '#6ee7b7',
            border: '1px solid rgba(16,185,129,0.25)',
          }}
        >
          {sharing ? '...' : '📤'}
        </button>
        <div className="flex items-center gap-1 rounded-full bg-gradient-to-r from-yellow-500/15 to-amber-500/15 px-3 h-8 border border-yellow-500/20">
          <span className="text-yellow-400 text-[14px]">💰</span>
          <span className="text-[14px] font-bold text-yellow-300 tabular-nums">
            {chips.toLocaleString()}
          </span>
        </div>
        {profile?.winStreak > 0 && (
          <div className="flex items-center rounded-full bg-red-500/15 px-2.5 h-8 text-[13px] font-bold text-red-400 border border-red-500/20">
            🔥 {profile.winStreak}
          </div>
        )}
      </div>
    </div>
  )
}
